import { DOCUMENT } from '@angular/common';
import { inject, Injectable, RendererFactory2 } from '@angular/core';
import { AppConfig } from '@common/tokens/app-configs.constant';
import { WINDOW } from '@common/tokens/window.constant';

@Injectable({
  providedIn: 'root'
})
export class GoogleTagManagerService {
  readonly renderer = inject(RendererFactory2).createRenderer(null, null);
  readonly window = inject(WINDOW);
  readonly appConfig = inject(AppConfig);
  readonly document = inject(DOCUMENT);

  public addScript(): void {
    const key = this.appConfig.googleTagManagerKey;
    if (!key) {
      return;
    }
    const scriptTag = this.renderer.createElement('script');
    const script = this.renderer.createElement('script');
    scriptTag.src = `https://www.googletagmanager.com/gtag/js?id=${key}`;
    script.type = 'text/javascript';
    script.innerHTML = `
    window.dataLayer = window.dataLayer || [];
    function gtag(){dataLayer.push(arguments);}
    gtag('js', new Date());
    gtag('config', '${key}');
    `;
    this.renderer.appendChild(this.document.getElementsByTagName('head')[0], script);
    this.renderer.appendChild(this.document.getElementsByTagName('head')[0], scriptTag);
  }

  public pushEvent(name: string, option?: Record<string, unknown>): void {
    this.getDataLayer().push({ event: name, ...option });
  }

  private getDataLayer(): any[] {
    return (this.window as any).dataLayer || [];
  }
}
